import NavDropdown from "component/react-bootstrap/NavDropdown";
import { memo } from "react";

function HoverNavDropdown(props: any) {
  const {
    children, inDom = false, onToggle, id, setShow, show, ...rest
  } = props;

  const clickHandler = () => {
    setShow({
      id, open: true,
    });
  };

  return (
    <>
      <NavDropdown
        id={id}
        onToggle={(a: any, event) => {
          onToggle(a, id, event);
        }}
        show={show.open && id === show.id}
        onClick={clickHandler}
        {...rest}
      >
        {((show.open && id === show.id) || inDom) ? children : ""}
      </NavDropdown>
    </>
  );
}

export default memo(HoverNavDropdown);
